import React from 'react';
import { Grid } from '@material-ui/core';
import Login from '../../../../widgets/Login';

const Component = ({ actions }) => (
    <Grid container justify="center">
        <Grid item xs={12}>
            <p className="text_login">Entrez votre identifiant</p>
            <Login actions={actions} />
        </Grid>
    </Grid>
);

export default Component;
